import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c40d0a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "operations"
}
const _hoisted_2 = { class: "add-icon__label" }

import { ref, computed, watch } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import { useI18n } from 'vue-i18n'
import type { TreeOption } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import TreeNav from './treeNav.vue'
import useNav from '../useNav'
import aclRules from '@teams/common/acl/aclRules'
import { useAcl } from 'vue-simple-acl'
import useMitt from '@/hooks/useMitt'
import { events, elementIds } from '@/constants'
import { Nav } from '@teams/common/models'
import AppManagement from './appManagement/index.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

_useCssVars(_ctx => ({
  "b7631e58": (_unref(navListStyle).gap)
}))

const acl = useAcl()
const showNavAdd = computed(() => {
  return acl.can(aclRules.navigation_add_tag)
})
const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.navigator.navs.${key}`, ...params)
}

const {
  expandedNavIds,
  selectedTreeNavIds,
  navSortable,
  addSubNav,
  treeNavs,
  addNav,
  treeNavNodeProps,
  handleTreeNavDrop,
  onExpandedNavIdsChange,
  isDragging,
  dragEnd,
  dragStart
} = useNav()
const gap = 0
const navListStyle = computed(() => ({
  gap: `${gap}px`
}))

const emitter = useMitt()
const addNavRef = ref<ComponentPublicInstance>()

watch(addNavRef, value => {
  if (value) {
    emitter.emit(events.elementRendered, {
      key: elementIds.addNavBtn,
      value: value.$el
    })
  }
})

function onAddSubNavClick(params: TreeOption) {
  addSubNav(params.data as Nav)
}

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createBlock(_component_n_space, {
    vertical: "",
    size: gap
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_space, {
        vertical: "",
        size: gap
      }, {
        default: _withCtx(() => [
          _createVNode(TreeNav, {
            draggable: _unref(navSortable),
            "expanded-keys": _unref(expandedNavIds),
            "selected-keys": _unref(selectedTreeNavIds),
            data: _unref(treeNavs),
            "node-props": _unref(treeNavNodeProps),
            "on-update:expanded-keys": _unref(onExpandedNavIdsChange),
            isDragging: _unref(isDragging),
            onDrop: _unref(handleTreeNavDrop),
            onDragend: _unref(dragEnd),
            onDragstart: _unref(dragStart),
            "onAdd:subNav": onAddSubNavClick
          }, null, 8, ["draggable", "expanded-keys", "selected-keys", "data", "node-props", "on-update:expanded-keys", "isDragging", "onDrop", "onDragend", "onDragstart"]),
          (_unref(showNavAdd))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "add-icon",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(addNav) && _unref(addNav)(...args))),
                  ref_key: "addNavRef",
                  ref: addNavRef
                }, [
                  _createVNode(_unref(Icon), {
                    name: "addNav",
                    fill: "transparent",
                    size: 20
                  }),
                  _createElementVNode("span", _hoisted_2, _toDisplayString($tt('addNav')), 1)
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(AppManagement)
    ]),
    _: 1
  }))
}
}

})